import InputField from './InputField';

export default InputField;


// WEBPACK FOOTER //
// ./src/components/forms/InputField/index.js